module.exports = __webpack_public_path__ + "img/icon-download-blue-dark.fafe5cb5.svg";